import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  QueryList
} from '@angular/core';
import { Subscription } from 'rxjs';

import { TabService } from '../tab/tab.service';
import { TabButtonComponent } from '../tab-button/tab-button.component';
import { attrToNumber } from '../../utils';

@Component({
  selector: 'ui-tab-bar',
  templateUrl: './tab-bar.component.html'
})
export class TabBarComponent implements OnDestroy, AfterContentInit {
  @ContentChildren(TabButtonComponent) tabBarItems: QueryList<TabButtonComponent>;

  @Input()
  set tabIndex(v: number) {
    this._tabIndex = attrToNumber(v);
    if (this.tabBarItems) {
      this.tabService.publishIndex(v);
    }
  }

  get tabIndex() {
    return this._tabIndex;
  }

  private _tabIndex = 0;
  private subs: Subscription[] = [];
  private itemSubs: Subscription[] = [];

  constructor(private tabService: TabService) {
  }

  listen() {
    this.itemSubs.forEach(item => {
      item.unsubscribe();
    });
    this.itemSubs = [];
    this.tabBarItems.forEach((item: TabButtonComponent, index: number) => {
      this.itemSubs.push(item.uiSelected.subscribe(() => {
        this.tabService.publishIndex(index);
      }));
    });
  }

  ngAfterContentInit() {
    // å½ç¨æ·ç¹å»æéä¸­æä¸ä¸ªææ­æ¶ï¼åå¸ç¸åºäºä»¶
    this.listen();
    this.tabBarItems.changes.subscribe(() => {
      this.listen();
    });
    // å½ç¨æ·åæ¢tabæ¶ï¼æ¾ç¤º/éèå¯¹åºè§å¾
    this.subs.push(this.tabService.tabIndex.subscribe((index: number) => {
      this.tabBarItems.forEach((item: TabButtonComponent, i: number) => {
        item.active = i === index;
      });
    }));

    this.tabService.publishIndex(this.tabIndex);
  }

  ngOnDestroy() {
    this.subs.forEach(item => {
      item.unsubscribe();
    });
    this.itemSubs.forEach(item => {
      item.unsubscribe();
    });
  }
}
